<template>
    <v-dialog
        v-model="dialog"
        :max-width="dialog_width"
        :persistent="saveLoading"
    >
        <div class="tw-flex tw-flex-col side-site-padding tw-gap-2">
                <h2 class="tw-capitalize tw-text-secondary">
                    {{ mode }} Member Skill
                </h2>
                <v-form name="editForm" ref="editForm">
                    <div>
                        <v-autocomplete
                            label="Skills"
                            :items="values_skills"
                            v-model="modelObject.skill_id"
                            outlined
                            dense
                            clearable
                            :rules="[rules.required]"
                        ></v-autocomplete>
                        <v-textarea
                            label="Notes"
                            v-model="modelObject.note"
                            outlined
                            auto-grow
                            compact
                        >
                        </v-textarea>

                            <date-picker
                                v-model="modelObject.date_course"
                                dense
                                color="primary"
                                display-label="Course date"
                                reactive
                                ref="datePicker"
                            />
                            <date-picker
                                v-model="modelObject.date_expire"
                                dense
                                color="primary"
                                display-label="Expire date"
                                reactive
                                ref="datePicker2"
                            />


                    </div>
                </v-form>
                <div class="tw-flex tw-flex-row tw-justify-center tw-gap-3">
                    <v-btn
                        text
                        @click="archiveMemberSkill(skill)"
                        :loading="archiveLoading"
                        v-show="is_edit_mode"
                    >
                        Delete
                    </v-btn>
                    <v-btn
                        text
                        @click="cancelDialog"
                        class="main-btn"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        text
                        @click="saveModel"
                        class="main-btn"
                        :loading="saveLoading"
                    >
                        Save
                    </v-btn>

                </div>
            </div>
    </v-dialog>
</template>

<script>
import DatePicker from "@/Generic/DatePicker";
import WYSIWYG from "@/Generic/WYSIWYG";

export default {
    name: "EditSpecialSkillsModal",
    components: {
        DatePicker,

    },
    props: {
        'value': {
            // The visibility of the dialog.  To be used with `v-model`
            required: true
        },
        'modelProp': {
            // The model we want to show details for (model is generic and don't require to be modified for each reuse of this modal)
            type: Object,
            required: false
        },
        'memberId': {
            // The model we want to show details for (model is generic and don't require to be modified for each reuse of this modal)
            type: Number,
            required: false
        },
        'valuelists': {
            type: Object,
            required: false
        },
    },
    data() {
        return {
            dialog: this.value || false,
            valuelist: this.valuelists,
            skill: undefined,
            member_id: this.memberId || '',
            mode: 'Add',
            modelObject: this.modelProp || {},
            modelDefault: {
                id: null,
                skill_id: null,
                note: null,
                date_course: null,
                date_expire: null,
            },
            saveLoading: false,
            rules: {
                required: value => !!value || 'Required',
            },
            archiveLoading: false,

        }
    },
    mounted() {

    },
    computed: {
        dialog_width() {
            return '40%'
        },
        values_skills() {
            if (this?.valuelists?.SKILLS_GROUPED) {
                return Object.values(this.valuelists?.SKILLS_GROUPED)
            }
            return []
        },
        is_edit_mode() {
            return this.mode == 'Edit' ? true : false
        }
    },
    methods: {
        activeOption(option) {
            if( this.activeOptions.includes(option) ){
                return true
            }
            return false
        },
        resetModel() {
            this.modelObject = structuredClone(this.modelDefault)
        },
        cancelDialog() {
            if (!this.loading) {
                this.dialog = false
            }
        },
        saveModel() {
            //let payload = this.modelObject

            if (this.$refs.editForm.validate()) {
                let formData = new FormData()

                if(typeof this.modelObject.date_course !== 'undefined' && this.modelObject.date_course !== null ) {
                    formData.append("date_course", this.modelObject.date_course)
                }
                if(typeof this.modelObject.date_expire !== 'undefined' && this.modelObject.date_expire !== null) {
                    formData.append("date_expire", this.modelObject.date_expire)
                }

                if(this.modelObject.skill_id == null){
                    this.$root.snackbar.error('A skill is required')
                }

                if(typeof this.modelObject.note !== 'undefined' && this.modelObject.note !== null) {
                    formData.append("note", this.modelObject.note)
                }

                formData.append("skill_id", this.modelObject.skill_id)

                let url = route('memberskills.store')

                if (this.is_edit_mode) {
                    url = route('memberskills.update', this.modelObject.id)
                    formData.append("_method", "put")
                    formData.append("user_id", this.modelObject.user_id)
                }else{
                    formData.append("user_id", this.member_id)
                }

                axios({
                    method: 'post',
                    url: url,
                    data: formData,
                })
                    .then(response =>
                    {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Changes have been saved')
                            this.dialog = false
                            this.$root.is_dirty = false
                            this.$emit('successful-skill-save')

                            // this.saveLoading = false
                        } else if( response.data?.error ) {
                            throw (response.data?.error)
                        } else {
                            throw ('Unknown error.')
                        }
                    })
                    .catch((error) => {
                        if( error?.response ) {
                            this.$root.snackbar.error(error.response.data.message)
                        } else {
                            console.log(error)
                            this.$root.snackbar.error(error)
                        }
                        this.saveLoading = false
                    })
            } else {
                this.$root.snackbar.error('Please fill all required fields.')
            }
        },

        async archiveMemberSkill(skill)
        {
            if (await this.$root.confirm.open(`Delete Member Skill`, `You are about to delete ${this.modelObject.skill_name}`)) {

                let method = 'delete'
                let url = route('memberskills.destroy', this.modelObject.id)

                axios({
                    method: method,
                    url: url,
                    data: skill,
                    onUploadProgress: (evt) => {
                        this.archiveLoading = !this.archiveLoading
                    },
                    onDownloadProgress: (evt) => {
                        this.archiveLoading = !this.archiveLoading
                    },
                })
                    .then(response => {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Member skill has been deleted')
                            this.dialog = false
                            this.$root.is_dirty = false
                            this.archiveLoading = false
                            this.$emit('successful-skill-delete')

                            this.$inertia.reload({only: ['input']})
                        } else {
                            throw (response.data.error)
                        }
                    })
                    .catch((error) => {
                        this.$root.snackbar.error(error.response.data.message)
                        this.archiveLoading = false
                    })
            }
        }
    },
    watch: {
        value(newInput, oldInput) {
            this.dialog = newInput
        },
        dialog(newDialog, oldDialog) {

            this.$emit('input', newDialog)
            if (newDialog === false) {
                // Closing modal
                this.activeEditor1 = false
                this.$refs.editForm.resetValidation()
            } else {
                // Opening modal
                if (this.modelProp === null) {
                    this.mode = 'Add'
                    this.modelObject = structuredClone(this.modelDefault)
                } else {
                    this.mode = 'Edit'
                    this.modelObject = structuredClone(JSON.parse(JSON.stringify(this.modelProp)))
                    if (typeof this.$refs.datePicker !== 'undefined'){
                        this.$refs.datePicker.date_temp = this.modelObject.date_course
                    }
                    if (typeof this.$refs.datePicker2 !== 'undefined'){
                        this.$refs.datePicker2.date_temp = this.modelObject.date_expire
                    }
                }
            }
        },
        'modelObject.date_course'(newDate) {
            if (typeof this.$refs.datePicker !== 'undefined'){
                this.$refs.datePicker.date_temp = newDate
            }
        },
        'modelObject.date_expire'(newDate) {
            if (typeof this.$refs.datePicker2 !== 'undefined'){
                this.$refs.datePicker2.date_temp = newDate
            }
        },
        // modelProp: {
        //     handler(newVal) {
        //         this.skill = newVal?.skill?.id
        //         this.modelObject = newVal || {}; // Update modelObject when modelProp changes
        //     },
        //     immediate: true // Trigger the watcher immediately when the component is created
        // },

    },
}
</script>
<style scoped>
</style>
